module.exports = __webpack_public_path__ + "media/images/div_lens/div-indian-3eea8bffdec9fe216d37588b69164944.png";